export default {
  methods: {
    graphicMaxValue(series) {
      let maxValue = 0;
      if (Array.isArray(series[0])) {
        maxValue = Math.max.apply(Math, series.map(item => Math.max.apply(Math, item))); // eslint-disable-line
      } else {
        maxValue = Math.max.apply(Math, series); // eslint-disable-line
      }
      return maxValue;
    },
    graphicScale(maxValue) {
      return maxValue / 10;
    },
    graphicTicks(maxValue) {
      const scale = this.graphicScale(maxValue);
      const ticks = [];
      for (let i = 0; i < maxValue + scale; i += scale) { // eslint-disable-line
        ticks.push(i);
      }
      return ticks;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/ctBarLabels.js